<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>订货数据</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 主卡：双 Tab（美团配送单 / 食亨销售单） -->
    <el-card class="main-card">
      <div slot="header" class="toolbar">
        <span class="card-header">
          订货数据
          <span class="header-summary">归集口径：单据自带编码 → 门店映射（美团管家编码 / 食亨编码）</span>
        </span>
        <span class="toolbar-tip">美团管家每日 04:00 采集 · 食亨订货通每日 04:20 采集（T-1 昨日单据）</span>
      </div>

          <!-- 指标卡：5 张（随筛选联动，平台随筛选区单选切换） -->
          <div v-if="activeTab === 'meituan'" class="stat-cards">
            <div class="stat-card">
              <div class="stat-card-num">{{ meituan.stats.count || 0 }}</div>
              <div class="stat-card-label">单据数</div>
            </div>
            <div class="stat-card">
              <div class="stat-card-num">{{ fmtMoney(meituan.stats.moneySum) }}</div>
              <div class="stat-card-label">金额合计（元）</div>
            </div>
            <div class="stat-card">
              <div class="stat-card-num">{{ fmtMoney(meituan.stats.feeSum) }}</div>
              <div class="stat-card-label">运费合计（元）</div>
            </div>
            <div class="stat-card">
              <div class="stat-card-num">{{ meituan.stats.goodsTotalSum || 0 }}</div>
              <div class="stat-card-label">货品总数（件）</div>
            </div>
            <div class="stat-card" :class="{ warn: (meituan.stats.unassigned || 0) > 0 }">
              <div class="stat-card-num">{{ meituan.stats.unassigned || 0 }}</div>
              <div class="stat-card-label">未归属单据</div>
            </div>
          </div>

          <!-- 食亨指标卡（随筛选区单选切换显示） -->
          <div v-if="activeTab === 'shiheng'" class="stat-cards">
            <div class="stat-card">
              <div class="stat-card-num">{{ shiheng.stats.count || 0 }}</div>
              <div class="stat-card-label">单据数</div>
            </div>
            <div class="stat-card">
              <div class="stat-card-num">{{ fmtMoney(shiheng.stats.moneySum) }}</div>
              <div class="stat-card-label">金额合计（元）</div>
            </div>
            <div class="stat-card">
              <div class="stat-card-num">{{ fmtMoney(shiheng.stats.feeSum) }}</div>
              <div class="stat-card-label">配送费合计（元）</div>
            </div>
            <div class="stat-card">
              <div class="stat-card-num">{{ shiheng.stats.goodsTotalSum || 0 }}</div>
              <div class="stat-card-label">货品总数（件）</div>
            </div>
            <div class="stat-card" :class="{ warn: (shiheng.stats.unassigned || 0) > 0 }">
              <div class="stat-card-num">{{ shiheng.stats.unassigned || 0 }}</div>
              <div class="stat-card-label">未归属单据</div>
            </div>
          </div>

          <!-- 筛选行：平台单选切换（美团配送单/食亨销售单），各平台筛选状态独立保留 -->
          <div class="filter-row">
            <el-radio-group v-model="activeTab" size="medium" @change="handleTabChange">
              <el-radio-button label="meituan">美团管家</el-radio-button>
              <el-radio-button label="shiheng">食亨系统</el-radio-button>
            </el-radio-group>
            <template v-if="activeTab === 'meituan'">
            <el-date-picker
              v-model="meituan.filterDateRange"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="medium"
              style="width: 260px; margin-left: 10px;"
              :clearable="false"
              @change="handleFilterChange('meituan')"
            ></el-date-picker>
            <el-input v-model="meituan.filterProject" placeholder="项目名" clearable size="medium" style="width: 140px; margin-left: 10px;" @keyup.enter.native="handleFilterChange('meituan')" @clear="handleFilterChange('meituan')"></el-input>
            <el-input v-model="meituan.filterKeyword" placeholder="单号/订货方/编码" clearable size="medium" style="width: 190px; margin-left: 10px;" @keyup.enter.native="handleFilterChange('meituan')" @clear="handleFilterChange('meituan')"></el-input>
            <el-select v-model="meituan.filterStatus" placeholder="单据状态" clearable size="medium" style="width: 115px; margin-left: 10px;" @change="handleFilterChange('meituan')">
              <el-option label="待发货" :value="301"></el-option>
              <el-option label="已发货" :value="304"></el-option>
            </el-select>
            <el-select v-model="meituan.filterOwner" placeholder="归属状态" clearable size="medium" style="width: 115px; margin-left: 10px;" @change="handleFilterChange('meituan')">
              <el-option label="已归属" value="assigned"></el-option>
              <el-option label="未归属" value="unassigned"></el-option>
            </el-select>
            <el-button type="primary" size="medium" style="margin-left: 10px;" @click="handleFilterChange('meituan')">查询</el-button>
            <el-button size="medium" icon="el-icon-download" style="margin-left: 10px;" @click="handleExport('meituan')">导出</el-button>
            </template>
            <template v-else>
              <el-date-picker
                v-model="shiheng.filterDateRange"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="medium"
                style="width: 260px; margin-left: 10px;"
                :clearable="false"
                @change="handleFilterChange('shiheng')"
              ></el-date-picker>
              <el-input v-model="shiheng.filterProject" placeholder="项目名" clearable size="medium" style="width: 140px; margin-left: 10px;" @keyup.enter.native="handleFilterChange('shiheng')" @clear="handleFilterChange('shiheng')"></el-input>
              <el-input v-model="shiheng.filterKeyword" placeholder="单号/订货方/编码" clearable size="medium" style="width: 190px; margin-left: 10px;" @keyup.enter.native="handleFilterChange('shiheng')" @clear="handleFilterChange('shiheng')"></el-input>
              <el-select v-model="shiheng.filterOwner" placeholder="归属状态" clearable size="medium" style="width: 115px; margin-left: 10px;" @change="handleFilterChange('shiheng')">
                <el-option label="已归属" value="assigned"></el-option>
                <el-option label="未归属" value="unassigned"></el-option>
              </el-select>
              <el-button type="primary" size="medium" style="margin-left: 10px;" @click="handleFilterChange('shiheng')">查询</el-button>
              <el-button size="medium" icon="el-icon-download" style="margin-left: 10px;" @click="handleExport('shiheng')">导出</el-button>
            </template>
            <span class="toolbar-tip" style="margin-left: auto;">共 {{ activeTab === 'meituan' ? meituan.total : shiheng.total }} 条</span>
          </div>

          <el-table v-if="activeTab === 'meituan'" v-loading="meituan.loading" :data="meituan.list" border stripe max-height="560" :row-class-name="rowClassName">
            <el-table-column label="#" type="index" width="50" :index="i => indexMethod('meituan', i)"></el-table-column>
            <el-table-column label="单号" width="170">
              <template slot-scope="scope">
                <div class="project-name">{{ scope.row.orderSn }}</div>
                <div class="text-content">制单 {{ fmtTime(scope.row.createTime) }}</div>
              </template>
            </el-table-column>
            <el-table-column label="订货方" min-width="150">
              <template slot-scope="scope">
                <div class="project-name">{{ scope.row.applyOrgName }}</div>
                <div class="text-content">{{ scope.row.applyOrgCode }}</div>
              </template>
            </el-table-column>
            <el-table-column label="归属项目" min-width="160">
              <template slot-scope="scope">
                <template v-if="scope.row.owner">
                  <div class="project-name">
                    {{ scope.row.owner.projectName }}
                    <el-tag v-if="scope.row.owner.via === 'history'" size="mini" type="info" style="margin-left: 2px;">历史归属</el-tag>
                  </div>
                  <div v-if="scope.row.owner.via === 'history'" class="text-content">编码 {{ scope.row.applyOrgCode }} 已转出，单据日期早于转移日</div>
                </template>
                <template v-else>
                  <div class="unassigned-text">未归属</div>
                  <div class="unassigned-sub">编码 {{ scope.row.applyOrgCode }} 待财务补录映射</div>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="供货方" width="130" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class="text-content">{{ scope.row.supplierName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="发货仓库" width="140" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.warehouseNames && scope.row.warehouseNames.length" class="text-content">{{ scope.row.warehouseNames.join('、') }}</span>
                <span v-else class="muted-text">—</span>
              </template>
            </el-table-column>
            <el-table-column label="种类数" width="70" align="center">
              <template slot-scope="scope">{{ scope.row.goodsCount }}</template>
            </el-table-column>
            <el-table-column label="货品总数" width="80" align="center">
              <template slot-scope="scope">{{ scope.row.goodsTotal }}</template>
            </el-table-column>
            <el-table-column label="金额（元）" width="110" align="right">
              <template slot-scope="scope">
                <span class="money-text">{{ fmtMoney(scope.row.money) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="运费（元）" width="100" align="right">
              <template slot-scope="scope">
                <span v-if="scope.row.freightFee !== null && scope.row.freightFee !== undefined" class="text-content">{{ fmtMoney(scope.row.freightFee) }}</span>
                <span v-else class="muted-text">—</span>
              </template>
            </el-table-column>
            <el-table-column label="单据状态" width="86" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.statusCode === 301 ? 'warning' : 'success'" size="small" effect="dark">{{ scope.row.statusCode === 301 ? '待发货' : '已发货' }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="单据日期" width="100" align="center">
              <template slot-scope="scope">
                <span class="text-content">{{ fmtDate(scope.row.createTime) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="70" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" plain @click="openDetailDialog(scope.row)">明细</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            v-if="activeTab === 'meituan'"
            style="margin-top: 15px; text-align: right;"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="meituan.total"
            :current-page.sync="meituan.pagenum"
            :page-sizes="[10, 20, 50]"
            :page-size.sync="meituan.pagesize"
            @current-change="fetchList('meituan')"
            @size-change="handleSizeChange('meituan')"
          ></el-pagination>
          <el-table v-if="activeTab === 'shiheng'" v-loading="shiheng.loading" :data="shiheng.list" border stripe max-height="560" :row-class-name="rowClassName">
            <el-table-column label="#" type="index" width="50" :index="i => indexMethod('shiheng', i)"></el-table-column>
            <el-table-column label="单号" width="170">
              <template slot-scope="scope">
                <div class="project-name">{{ scope.row.orderNo }}</div>
                <div class="text-content">下单 {{ fmtTime(scope.row.purchaseTime) }}</div>
              </template>
            </el-table-column>
            <el-table-column label="订货方" min-width="150">
              <template slot-scope="scope">
                <div class="project-name">{{ scope.row.customerName }}</div>
                <div class="text-content">{{ scope.row.customerCode }}</div>
              </template>
            </el-table-column>
            <el-table-column label="归属项目" min-width="160">
              <template slot-scope="scope">
                <template v-if="scope.row.owner">
                  <div class="project-name">
                    {{ scope.row.owner.projectName }}
                    <el-tag v-if="scope.row.owner.via === 'history'" size="mini" type="info" style="margin-left: 2px;">历史归属</el-tag>
                  </div>
                  <div v-if="scope.row.owner.via === 'history'" class="text-content">编码 {{ scope.row.customerCode }} 已转出，单据日期早于转移日</div>
                </template>
                <template v-else>
                  <div class="unassigned-text">未归属</div>
                  <div class="unassigned-sub">编码 {{ scope.row.customerCode }} 待财务补录映射</div>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="供货方" width="130" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class="text-content">{{ scope.row.deliveryCenter }}</span>
              </template>
            </el-table-column>
            <el-table-column label="发货仓库" width="110" show-overflow-tooltip>
              <template slot-scope="scope">
                <span class="text-content">{{ scope.row.shippingWarehouse }}</span>
              </template>
            </el-table-column>
            <el-table-column label="种类数" width="70" align="center">
              <template slot-scope="scope">{{ scope.row.goodsCategoryCount }}</template>
            </el-table-column>
            <el-table-column label="货品总数" width="80" align="center">
              <template slot-scope="scope">{{ scope.row.orderCount }}</template>
            </el-table-column>
            <el-table-column label="金额（元）" width="110" align="right">
              <template slot-scope="scope">
                <span class="money-text">{{ fmtMoney(scope.row.originAmount) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="运费（元）" width="100" align="right">
              <template slot-scope="scope">
                <span v-if="scope.row.deliveryFee > 0" class="text-content">{{ fmtMoney(scope.row.deliveryFee) }}</span>
                <span v-else class="muted-text">—</span>
              </template>
            </el-table-column>
            <el-table-column label="单据状态" width="86" align="center">
              <template slot-scope="scope">
                <el-tag type="success" size="small" effect="dark">{{ scope.row.receiptStatus === 1 ? '已结清' : '待收款' }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="单据日期" width="100" align="center">
              <template slot-scope="scope">
                <span class="text-content">{{ fmtDate(scope.row.purchaseTime) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="70" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" plain @click="openDetailDialog(scope.row)">明细</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            v-if="activeTab === 'shiheng'"
            style="margin-top: 15px; text-align: right;"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="shiheng.total"
            :current-page.sync="shiheng.pagenum"
            :page-sizes="[10, 20, 50]"
            :page-size.sync="shiheng.pagesize"
            @current-change="fetchList('shiheng')"
            @size-change="handleSizeChange('shiheng')"
          ></el-pagination>
    </el-card>

    <!-- 明细钻取弹窗：单头摘要 + 交叉校验 + 明细表（两平台共用，按 platform 分支渲染） -->
    <el-dialog v-loading="detailLoading" :title="detailTitle" :visible.sync="detailVisible" width="960px" top="6vh">
      <template v-if="detailData && detailData.order">
        <!-- 单头摘要：美团 -->
        <div v-if="detailData.platform === 'meituan'" class="summary-row">
          <div class="summary-item"><span class="summary-label">订货方</span><span>{{ detailData.order.applyOrgName }}（{{ detailData.order.applyOrgCode }}）</span></div>
          <div class="summary-item"><span class="summary-label">归属项目</span>
            <span v-if="detailData.order.owner">{{ detailData.order.owner.projectName }}{{ detailData.order.owner.via === 'history' ? '（历史归属）' : '' }}</span>
            <span v-else class="unassigned-text">未归属</span>
          </div>
          <div class="summary-item"><span class="summary-label">供货方</span><span>{{ detailData.order.supplierName }}</span></div>
          <div class="summary-item"><span class="summary-label">金额</span><span class="money-text">{{ fmtMoney(detailData.order.money) }} 元</span></div>
          <div class="summary-item"><span class="summary-label">运费</span><span>{{ detailData.order.freightFee !== null && detailData.order.freightFee !== undefined ? fmtMoney(detailData.order.freightFee) + ' 元' : '—' }}</span></div>
          <div class="summary-item"><span class="summary-label">单据状态</span>
            <el-tag :type="detailData.order.statusCode === 301 ? 'warning' : 'success'" size="small" effect="dark">{{ detailData.order.statusCode === 301 ? '待发货' : '已发货' }}</el-tag>
          </div>
        </div>
        <!-- 单头摘要：食亨 -->
        <div v-else class="summary-row">
          <div class="summary-item"><span class="summary-label">订货方</span><span>{{ detailData.order.customerName }}（{{ detailData.order.customerCode }}）</span></div>
          <div class="summary-item"><span class="summary-label">归属项目</span>
            <span v-if="detailData.order.owner">{{ detailData.order.owner.projectName }}{{ detailData.order.owner.via === 'history' ? '（历史归属）' : '' }}</span>
            <span v-else class="unassigned-text">未归属</span>
          </div>
          <div class="summary-item"><span class="summary-label">供货方</span><span>{{ detailData.order.deliveryCenter }}</span></div>
          <div class="summary-item"><span class="summary-label">发货仓库</span><span>{{ detailData.order.shippingWarehouse }}</span></div>
          <div class="summary-item"><span class="summary-label">金额</span><span class="money-text">{{ fmtMoney(detailData.order.originAmount) }} 元</span></div>
          <div class="summary-item"><span class="summary-label">运费</span><span>{{ detailData.order.deliveryFee > 0 ? fmtMoney(detailData.order.deliveryFee) + ' 元' : '—' }}</span></div>
          <div class="summary-item"><span class="summary-label">单据状态</span>
            <el-tag type="success" size="small" effect="dark">{{ detailData.order.receiptStatus === 1 ? '已结清' : '待收款' }}</el-tag>
          </div>
        </div>

        <!-- 交叉校验条：单头种类数/总数 vs 明细行数/数量合计 -->
        <el-alert
          v-if="detailData.checks.pass"
          type="success"
          :closable="false"
          show-icon
          :title="`对账一致：种类数 ${detailData.checks.headerCount} = 明细 ${detailData.checks.detailRows} 行；货品总数 ${detailData.checks.headerQty} = 明细数量合计 ${detailData.checks.detailQtySum}`"
          style="margin-bottom: 12px;"
        ></el-alert>
        <el-alert v-else type="error" :closable="false" show-icon style="margin-bottom: 12px;">
          <template slot="title">
            <span>对账不一致，请核对采集数据：</span>
            <div v-for="(d, i) in detailData.checks.diffs" :key="i" class="diff-line">{{ d }}</div>
          </template>
        </el-alert>

        <!-- 明细表（两平台字段已标准化：code/name/category/standard/unit/qty/price/amount/warehouse） -->
        <el-table :data="detailRows" border stripe size="small" max-height="420">
          <el-table-column label="#" type="index" width="45"></el-table-column>
          <el-table-column prop="code" label="货品编码" width="100"></el-table-column>
          <el-table-column prop="goodsName" label="货品名称" min-width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="category" label="类别" width="90"></el-table-column>
          <el-table-column prop="standard" label="规格" width="110" show-overflow-tooltip></el-table-column>
          <el-table-column prop="unitName" label="单位" width="60" align="center"></el-table-column>
          <el-table-column label="数量" width="70" align="right">
            <template slot-scope="scope">{{ scope.row.qty }}</template>
          </el-table-column>
          <el-table-column label="单价（元）" width="100" align="right">
            <template slot-scope="scope">{{ fmtMoney(scope.row.price) }}</template>
          </el-table-column>
          <el-table-column label="金额（元）" width="100" align="right">
            <template slot-scope="scope">{{ fmtMoney(scope.row.amount) }}</template>
          </el-table-column>
          <el-table-column label="发货仓库" width="110" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.warehouse">{{ scope.row.warehouse }}</span>
              <span v-else class="muted-text">未分配</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="detail-footer">共 {{ detailRows.length }} 行 · 数量合计 {{ detailData.checks.detailQtySum }} · 金额合计 {{ fmtMoney(detailMoneySum) }} 元</div>
      </template>
      <div slot="footer">
        <el-button type="primary" size="medium" @click="detailVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'FinanceOrderData',
  data () {
    return {
      activeTab: 'meituan',
      // 美团配送单（服务端分页：列表/统计随筛选查询；各平台筛选状态独立保留）
      meituan: {
        list: [],
        total: 0,
        stats: {},
        loading: false,
        filterDateRange: [],
        filterKeyword: '',
        filterProject: '',
        filterStatus: '',
        filterOwner: '',
        pagenum: 1,
        pagesize: 10
      },
      // 食亨销售单（服务端分页）
      shiheng: {
        list: [],
        total: 0,
        stats: {},
        loading: false,
        filterDateRange: [],
        filterKeyword: '',
        filterProject: '',
        filterOwner: '',
        pagenum: 1,
        pagesize: 10
      },
      // 明细钻取弹窗（两平台共用；detailData = { platform, order, rows, checks }，owner 挂在 order 上）
      detailVisible: false,
      detailData: null,
      detailLoading: false
    }
  },
  created () {
    // 默认查最近 7 天（含今天；跨日单/补采场景下比单日默认更不易漏看）
    const fmtDay = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
    const weekRange = [fmtDay(new Date(Date.now() - 6 * 86400000)), fmtDay(new Date())]
    this.meituan.filterDateRange = weekRange
    this.shiheng.filterDateRange = weekRange
    // 从「订货明细」页单号链接跳转进入：带平台、单号与日期范围定位单头（避免默认昨日导致首屏空）
    const q = this.$route.query || {}
    if (q.platform === 'shiheng') this.activeTab = 'shiheng'
    if (q.keyword) {
      const st = this.activeTab === 'meituan' ? this.meituan : this.shiheng
      st.filterKeyword = String(q.keyword)
      if (q.startDate && q.endDate) st.filterDateRange = [String(q.startDate), String(q.endDate)]
    }
    this.fetchList('meituan')
    this.fetchList('shiheng')
  },
  watch: {
  },
  computed: {
    /**
     * 明细弹窗：标题（按平台取单号）
     */
    detailTitle () {
      const o = this.detailData && this.detailData.order
      if (!o) return '单据明细'
      return o.orderSn ? `配送单明细 · ${o.orderSn}` : `销售单明细 · ${o.orderNo}`
    },

    /**
     * 明细弹窗：明细行（服务端字段标准化为弹窗共用列）
     */
    detailRows () {
      const platform = this.detailData && this.detailData.platform
      if (!platform) return []
      return (this.detailData.rows || []).map(r => ({
        code: platform === 'meituan' ? r.goodsSn : r.goodsCode,
        goodsName: r.goodsName,
        category: r.category,
        standard: r.standard,
        unitName: r.unitName,
        qty: platform === 'meituan' ? r.deliveryQuantity : r.orderQuantity,
        price: platform === 'meituan' ? r.deliveryPrice : r.price,
        amount: platform === 'meituan' ? r.deliveryMoney : r.subtotalAmount,
        warehouse: platform === 'meituan' ? r.deliveryWarehouseName : r.warehouseName
      }))
    },

    detailMoneySum () {
      return this.detailRows.reduce((s, r) => s + (r.amount || 0), 0)
    }
  },
  methods: {
    /**
     * 金额格式化：两位小数 + 千分位
     */
    fmtMoney (v) {
      if (v === null || v === undefined || isNaN(v)) return '—'
      return Number(v).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },

    /**
     * 日期格式化（东八区，YYYY-MM-DD）：后端返回 ISO 字符串，勿直接截取前 10 位（UTC 会差 8 小时）
     */
    fmtDate (v) {
      return v ? new Date(v).toLocaleDateString('sv-SE') : ''
    },

    /**
     * 时间格式化（东八区，MM-DD HH:mm）
     */
    fmtTime (v) {
      return v ? new Date(v).toLocaleString('sv-SE', { hour12: false }).slice(5, 16) : ''
    },

    /**
     * 分页序号（跨页连续，按平台各自计数）
     */
    indexMethod (platform, index) {
      const st = platform === 'meituan' ? this.meituan : this.shiheng
      return (st.pagenum - 1) * st.pagesize + index + 1
    },

    /**
     * 未归属行淡红背景
     */
    rowClassName ({ row }) {
      return row.owner ? '' : 'unassigned-row'
    },

    /**
     * 组装筛选参数（列表查询与导出共用，保证所见即所得）
     */
    _buildParams (platform) {
      const st = platform === 'meituan' ? this.meituan : this.shiheng
      const [startDate, endDate] = st.filterDateRange || []
      const params = { platform, pagenum: st.pagenum, pagesize: st.pagesize }
      if (startDate) params.startDate = startDate
      if (endDate) params.endDate = endDate
      if (st.filterKeyword.trim()) params.keyword = st.filterKeyword.trim()
      if (st.filterProject.trim()) params.project = st.filterProject.trim()
      if (platform === 'meituan' && st.filterStatus) params.statusCode = st.filterStatus
      if (st.filterOwner) params.ownerType = st.filterOwner
      return params
    },

    /**
     * 加载列表（服务端分页 + 统计 + 当页归集）
     */
    async fetchList (platform) {
      const st = platform === 'meituan' ? this.meituan : this.shiheng
      st.loading = true
      try {
        const { data: res } = await this.$http.get('finance/orderData/list', { params: this._buildParams(platform) })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        st.list = res.data.list || []
        st.total = res.data.total || 0
        st.stats = res.data.stats || {}
      } finally {
        st.loading = false
      }
    },

    /**
     * 平台单选切换：刷新目标平台（用户交互触发；筛选状态各平台独立保留）
     */
    handleTabChange (platform) {
      this.fetchList(platform)
    },

    /**
     * 筛选变化：回到第一页重新查询（列表与统计卡服务端联动）
     */
    handleFilterChange (platform) {
      const st = platform === 'meituan' ? this.meituan : this.shiheng
      st.pagenum = 1
      this.fetchList(platform)
    },

    /**
     * 每页条数变化：回到第一页重新查询
     */
    handleSizeChange (platform) {
      const st = platform === 'meituan' ? this.meituan : this.shiheng
      st.pagenum = 1
      this.fetchList(platform)
    },

    /**
     * 导出（所见即所得：与列表同筛选；后端生成 xlsx，独立「导出」权限）
     * 无权限/参数错误时后端返回 JSON（HTTP 200），需识别为错误而非落盘损坏文件（仓内 Dianpu 同模式）
     */
    async handleExport (platform) {
      const st = platform === 'meituan' ? this.meituan : this.shiheng
      if (!st.total) return this.$message.warning('当前筛选条件下无数据可导出')
      try {
        const { data } = await this.$http.get('finance/orderData/export', { params: this._buildParams(platform), responseType: 'blob' })
        if (data.type === 'application/json') {
          const err = JSON.parse(await data.text())
          return this.$message.error((err.meta && err.meta.msg) || '导出失败')
        }
        this._downloadBlob(data, `订货数据_${platform === 'meituan' ? '美团配送单' : '食亨销售单'}_${this._dateTag(st)}.xlsx`)
      } catch (err) {
        this.$message.error('导出失败')
      }
    },

    /**
     * 筛选日期段拼文件名用
     */
    _dateTag (st) {
      const [start, end] = st.filterDateRange || []
      if (start && end) return start === end ? String(start) : `${start}_${end}`
      return '全部'
    },

    /**
     * 通用的 Blob 文件下载方法
     */
    _downloadBlob (blob, filename) {
      const url = window.URL.createObjectURL(new Blob([blob]))
      const link = document.createElement('a')
      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },

    /**
     * 打开明细钻取弹窗（调后端 detail 接口：单头 + 归属 + 明细 + 交叉校验）
     */
    async openDetailDialog (row) {
      this.detailVisible = true
      this.detailData = null
      this.detailLoading = true
      try {
        const platform = this.activeTab
        const orderKey = platform === 'meituan' ? row.orderSn : row.orderNo
        const { data: res } = await this.$http.get('finance/orderData/detail', { params: { platform, orderKey } })
        if (res.meta.status !== 200) {
          this.detailVisible = false
          return this.$message.error(res.meta.msg)
        }
        this.detailData = { platform, ...res.data }
      } finally {
        this.detailLoading = false
      }
    }
  }
}
</script>

<style scoped>
.main-card {
  margin-top: 20px;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header {
  font-size: 16px;
  font-weight: bold;
}
.header-summary {
  font-size: 12px;
  font-weight: normal;
  color: #909399;
  margin-left: 12px;
}

.filter-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  padding-top: 12px;
  border-top: 1px solid #EBEEF5;
  flex-wrap: wrap;
  row-gap: 8px;
}

.toolbar-tip {
  color: #909399;
  font-size: 12px;
}

/* 表格内小字 */
.text-content {
  font-size: 12px;
  color: #909399;
}
.project-name {
  font-size: 13px;
  color: #303133;
}
.muted-text {
  color: #c0c4cc;
}
.money-text {
  color: #303133;
  font-weight: 500;
}

/* 未归属 */
.unassigned-text {
  color: #F56C6C;
  font-size: 13px;
  font-weight: 500;
}
.unassigned-sub {
  font-size: 12px;
  color: #F56C6C;
}
::v-deep .unassigned-row {
  background: #FEF0F0 !important;
}

/* 指标卡 */
.stat-cards {
  display: flex;
  gap: 12px;
}
.stat-card {
  flex: 1;
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  background: #FAFBFC;
  text-align: center;
}
.stat-card-num {
  font-size: 24px;
  font-weight: bold;
  line-height: 1.2;
  color: #303133;
}
.stat-card.warn .stat-card-num {
  color: #F56C6C;
}
.stat-card-label {
  font-size: 12px;
  color: #606266;
  margin-top: 2px;
}

/* 明细弹窗摘要行 */
.summary-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
  padding: 10px 12px;
  margin-bottom: 12px;
  background: #F5F7FA;
  border-radius: 4px;
  font-size: 13px;
  color: #303133;
}
.summary-item .summary-label {
  color: #909399;
  margin-right: 8px;
}
.diff-line {
  font-size: 12px;
  line-height: 1.8;
}
.detail-footer {
  margin-top: 10px;
  text-align: right;
  font-size: 12px;
  color: #909399;
}
</style>
